
import Vue from "vue";
import { formatDate, getFeatureData, parseDate, setFeatureDataItem, getToday } from "../../lib/util";
import Modal from "../Modal.vue";
import { COLLECT_YIELD_DATA_PERIOD } from "@/lib/constants";

export default Vue.extend({
  name: "LastSeasonYieldNoticePrompt",
  components: { Modal },
  data() {
    return {
      dismissedOnce: true as boolean,
    };
  },
  computed: {
    showNotice(): boolean {
      return !this.dismissedOnce && this.inNoticePeriod;
    },
    inNoticePeriod(): boolean {
      const today = getToday();
      return today >= COLLECT_YIELD_DATA_PERIOD.start && today <= COLLECT_YIELD_DATA_PERIOD.end;
    },
    lastSeasonYear(): string {
      return new Date().getFullYear().toString();
    },
  },
  mounted() {
    const lastShownDate = parseDate(getFeatureData("lastSeasonYieldNotice").lastShownDate);
    const ONE_WEEK = 7 * 24 * 60 * 60 * 1000;
    if (!lastShownDate || Date.now() >= lastShownDate.getTime() + ONE_WEEK) {
      this.dismissedOnce = this.inNoticePeriod ? false : true;
    }
  },
  methods: {
    async dismiss(this: any): Promise<void> {
      this.dismissedOnce = true;
      setFeatureDataItem("lastSeasonYieldNotice", "lastShownDate", formatDate(new Date()));
      this.$emit("dismiss");
    },
  },
});
